module.exports = __webpack_public_path__ + "media/images/press_kit/shoretime_bg/email/top-light-small-f45efcf23cce73a7ae5ba16066ece53d.png";